import React, { useContext } from 'react'
import { useTheme } from '@mui/material'
import messagesLib from '../../libs/messages'
import { findComponent } from '../TemplatePreviewBubble'
import { WabaTemplatesContext } from './context'

// Uma linha do que o cliente recebeu, com o que veio de variável realçado. É o
// que permite conferir "o ERP mandou o nome e o valor certos?" sem abrir nada.
// O nome do template não aparece mais aqui — foi para a coluna Modelo
// (TemplateCategoryBadge), que mostra a categoria com o nome no tooltip.
export default function MessagePeek({ message }) {
  const theme = useTheme()
  const templatesByName = useContext(WabaTemplatesContext)

  const dados = messagesLib.getWhatsappCloudApiTemplateData(message.message || '')
  // O mapa de templates é indexado em minúsculas (ver index.jsx) — sem o
  // lowercase aqui, o corpo aprovado nunca é encontrado quando o nome do
  // template vier com outra caixa, e a prévia cai sempre no fallback.
  const template = dados?.templateName ? templatesByName[String(dados.templateName).toLowerCase()] : null
  // `findComponent` é a mesma função que a bolha do preview usa: ela normaliza o
  // tipo, então variação de caixa no snapshot da Meta não faz a prévia ficar muda.
  const corpo = findComponent(template?.components, 'BODY')?.text || ''

  const tokens = messagesLib.buildMessagePeek(message.message || '', {
    link: message.link || '',
    templateBody: corpo,
  })

  // Sem tokens não há o que mostrar aqui — mesmo sendo template: o nome dele já
  // está na coluna Modelo, e sem o corpo aprovado (snapshot ainda não carregou)
  // ou variáveis enviadas não sobra nada pra essa prévia exibir.
  if (!tokens.length) return null

  // Sem margem própria: a prévia agora é uma célula da tabela, e qualquer
  // respiro por cima a tiraria do centro vertical da linha.
  return (
    <span className="block truncate text-xs opacity-80" style={{ color: theme.isDark ? '#aab6c2' : '#4a5661' }}>
      {tokens.map((token, i) =>
        token.kind === 'var' ? (
          <mark
            key={i}
            style={{
              backgroundColor: theme.isDark ? '#123b32' : '#e2f6f0',
              color: theme.isDark ? '#8ff0d6' : '#00543f',
              borderRadius: 3,
              padding: '0 3px',
            }}
          >
            {token.text}
          </mark>
        ) : (
          <span key={i}>{token.text}</span>
        )
      )}
    </span>
  )
}
